import { TcgDesignCard } from "@/components/cards/designs/tcg-design-card";
import type { FoilConfig } from "@/components/cards/foil/foil-config";

/**
 * Pokemon card — now powered by DesignMinimal.
 * Kept as a named export for backward compatibility with pack reveals and deck views.
 */
export const PokemonCard = ({
  pokeName,
  level = 36,
  isShiny,
  isFullArt,
  activeSkills,
  foil = true,
  autoShine = false,
}: {
  pokeName: string;
  level?: number;
  isShiny?: boolean;
  /** Show the full-art backdrop. Should mirror the Pokemon's is_full_art DB flag. */
  isFullArt?: boolean;
  /** Equipped skill ids; without this the card falls back to the full species pool. */
  activeSkills?: readonly string[];
  foil?: FoilConfig | boolean;
  autoShine?: boolean;
}) => (
  <TcgDesignCard
    pokeName={pokeName}
    level={level}
    isShiny={isShiny}
    isFullArt={isFullArt}
    activeSkills={activeSkills}
    foil={foil}
    autoShine={autoShine}
  />
);
